import { render } from "./RecipeView.vue?vue&type=template&id=117db15f&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"

import "./RecipeView.vue?vue&type=style&index=0&id=117db15f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117db15f"]])

export default __exports__